import React from 'react'
import Text from '../../components/Text'

interface Props {
  question: string,
  answer: string
}

const FaqCard: React.FC<Props> = ({ question = '', answer = '' }) => {
  return (
    <div>
      <Text
        tag="h2"
        style={{ color: 'rgba(0, 0, 0, 0.87)' }}
      >
        {question}
      </Text>

      <p
        style={{ whiteSpace: 'pre-wrap', color: 'rgb(117, 117, 117)', marginLeft: '0px' }}
        dangerouslySetInnerHTML={{ __html: answer }}
      >
      </p>

    </div>
  )
}

export default FaqCard
